/** Exact botanical paths from the approved homepage lockup. */
export const BRAND_SPRIG_PATHS = [
  "M7 41C17 31 23 21 31 5",
  "M19 28C11 29 7 25 5 20c8-1 13 1 16 6",
  "M25 19c-1-7 2-12 8-15 2 7 0 12-6 16",
  "M13 35c-6 1-10-1-12-5 6-2 11 0 14 3",
  "M22 27c6-1 11 1 15 5-7 3-12 1-16-3",
] as const;
